import React from 'react';
import { Text } from '@carnica/ui-kit';
export var Heading = function Heading(_ref) {
  var subtitle = _ref.subtitle,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    "data-t-id": "components-Heading"
  }, Boolean(title) && /*#__PURE__*/React.createElement(Text, {
    size: 16,
    tagName: "h3"
  }, title), Boolean(subtitle) && /*#__PURE__*/React.createElement(Text, {
    color: "secondary",
    size: 16,
    tagName: "p"
  }, subtitle));
};